import BannerHero from "@/components/bannerHero";
import SchoolCalendar from "@/components/schoolCalendar/SchoolCalendar";

export default function About() {
    return (
        <>
            <BannerHero
                title="School Calendar"
                bgImage="/images/about-bg.png"
                className="about"
            />
            <SchoolCalendar />
        </>
    );
}
